import {
  CloudflareDataAction,
  LOAD_CLOUDFLARE_DEFAULT_RECORD,
  LOAD_CLOUDFLARE_DEFAULT_RECORD_FAIL,
  LOAD_CLOUDFLARE_DEFAULT_RECORD_SUCCESS,
  LoadCloudflareDefaultRecord,
  LoadCloudflareDefaultRecordFail,
  LoadCloudflareDefaultRecordSuccess
} from "../actions";
import {DefaultRecord} from "../../websites/website/booster/mappers/cloudflare/default-record";


export interface ICloudflareDefaultRecordEntityState {
  dnsRecords: DefaultRecord;
  loading: boolean;
  loaded: boolean;
}

export interface ICloudflareDefaultRecordState {
  [websiteId: number]: ICloudflareDefaultRecordEntityState;
}

export const initialState: ICloudflareDefaultRecordState = {};


export function reducer(state: ICloudflareDefaultRecordState = initialState, action: CloudflareDataAction): ICloudflareDefaultRecordState {
  let payload: any;

  switch (action.type) {

    case LOAD_CLOUDFLARE_DEFAULT_RECORD:
      payload = (<LoadCloudflareDefaultRecord>action).payload;
      return {
        ...state,
        [payload]: {
          ...state[payload],
          loading: true,
          loaded: false
        }
      };

    case LOAD_CLOUDFLARE_DEFAULT_RECORD_SUCCESS:
      payload = (<LoadCloudflareDefaultRecordSuccess>action).payload;
      return {
        ...state,
        [payload.websiteId]: {
          ...state[payload.websiteId],
          dnsRecords: payload.dnsRecords,
          loading: false,
          loaded: true
        }
      };

    case LOAD_CLOUDFLARE_DEFAULT_RECORD_FAIL:
      payload = (<LoadCloudflareDefaultRecordFail>action).payload;

      return {
        ...state,
        [payload && payload.websiteId]: {
          ...state[payload && payload.websiteId],
          loading: false,
          loaded: true
        }
      };

  }

  return state;
}
